var map = {
  "./address.js": "80831",
  "./catalog.js": "51524",
  "./guide.js": "25743",
  "./kdTracking.js": "20533",
  "./layout.js": "33633",
  "./order.js": "37351",
  "./parcel.js": "93460",
  "./poll.js": "29078",
  "./post.js": "32749",
  "./search.js": "88763",
  "./shippingRate.js": "77519",
  "./theme.js": "81214",
  "./tpCatalog.js": "39984",
  "./tpTaobaoTrade.js": "95471",
  "./upyun.js": "78796",
  "./zipcodeTw.js": "47728"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function() { return Object.keys(map); };
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 14071;
